module.exports = __webpack_public_path__ + "img/thumb-cm.c056299.jpg";